import { render, staticRenderFns } from "./ModalIframe.vue?vue&type=template&id=36873ffd&scoped=true"
import script from "./ModalIframe.vue?vue&type=script&lang=js"
export * from "./ModalIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36873ffd",
  null
  
)

export default component.exports